// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"118":"css/lock","252":"css/app","615":"css/pdf"}[chunkId] + ".css";
};